import React, { Component } from 'react'
import {api} from "../../hooks/axios"
import { 
    Button, Container, Form, Card, Alert, Row, Col 
} from "react-bootstrap";
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setBook } from '../../context/actions/index';
import { FaBook, FaArrowLeft, FaSave, FaRocket } from 'react-icons/fa';
import './Books.css';

class CreateBook extends Component {
    data = JSON.parse(localStorage["user-data"]);
    
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            desc: '',
            submitted: false,
            navigate: false,
            loading: false,
            error: null
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!this.state.name || !this.state.desc) {
            this.setState({ error: "Harap lengkapi nama dan deskripsi buku" });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const response = await api.post('books', {
                    email: this.data.user_email,
                    name: this.state.name,
                    desc: this.state.desc,
                    role: 1,
                    status: 1,
                    user_id: this.data.user_id,
            });

            const result = await response;
            if (result.status=="201") {
                localStorage.setItem("bookId", result.data.messages.bookId);
                this.props.setBook(this.state);
                this.setState({ navigate: "/" });
            } else {
                throw new Error(result.message || "Gagal membuat buku");
            }

        } catch (error) {
            console.error("Error creating book:", error);
            this.setState({ 
                error: error.message || "Gagal membuat buku. Silakan coba lagi.", 
                loading: false 
            });
        }
    }

    render() {
        if (this.state.navigate) {
            return <Navigate to={this.state.navigate} />;
        }

        return (
            <div className="create-book-modern">
                <Container className="my-5">
                    <Row className="justify-content-center">
                        <Col lg={6} md={8}>
                            <Card className="create-book-card">
                                <Card.Header className="create-book-header">
                                    <Button 
                                        variant="link" 
                                        onClick={() => this.setState({ navigate: "/books" })}
                                        className="back-btn"
                                    >
                                        <FaArrowLeft className="me-2" />
                                        Kembali
                                    </Button>
                                    <h2 className="text-center mb-0">
                                        <FaBook className="me-3" />
                                        Buku Baru
                                    </h2>
                                </Card.Header>
                                
                                <Card.Body className="p-4">
                                    {this.state.error && (
                                        <Alert variant="danger" dismissible>
                                            {this.state.error}
                                        </Alert>
                                    )}

                                    <Form onSubmit={this.handleSubmit}>
                                        <Form.Group className="mb-4">
                                            <Form.Label className="form-label">
                                                Nama Buku
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.name}
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                placeholder="Beri nama yang mudah diingat"
                                                className="modern-input"
                                                required
                                            />
                                            <Form.Text className="text-muted">
                                                Contoh: Keuangan Keluarga, Usaha Toko, Tabungan Pribadi
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label className="form-label">
                                                Deskripsi Buku
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                value={this.state.desc}
                                                onChange={(e) => this.setState({ desc: e.target.value })}
                                                placeholder="Jelaskan tujuan buku ini..."
                                                className="modern-textarea"
                                                required
                                            />
                                            <Form.Text className="text-muted">
                                                Deskripsi membantu mengingat tujuan pembuatan buku ini
                                            </Form.Text>
                                        </Form.Group>

                                        <div className="book-tips">
                                            <h6>
                                                <FaRocket className="me-2" />
                                                Tips Membuat Buku yang Baik:
                                            </h6>
                                            <ul>
                                                <li>Beri nama yang spesifik dan mudah diingat</li>
                                                <li>Gunakan untuk kategori keuangan yang berbeda</li>
                                                <li>Contoh: "Keuangan Rumah Tangga", "Usaha Kafe", "Tabungan Pendidikan"</li>
                                            </ul>
                                        </div>

                                        <div className="form-actions">
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => this.setState({ navigate: "/books" })}
                                                disabled={this.state.loading}
                                            >
                                                Batal
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="primary"
                                                disabled={this.state.loading}
                                                className="submit-btn"
                                            >
                                                {this.state.loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" />
                                                        Membuat...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaSave className="me-2" />
                                                        Buat Buku
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    book: state.book
});

const mapDispatchToProps = dispatch => ({
    setBook: (book) => dispatch(setBook(book)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateBook);